import { colors } from './const';
import { scanInteractionIssues } from './project-source-scan';
import { resolveProjectRoot } from './resolve-project-root';

const c = colors;

export interface RunVerifyInteractionsOptions {
  projectRoot?: string;
  fromFetch?: boolean;
}

export function runVerifyInteractions(options: RunVerifyInteractionsOptions = {}): number {
  const projectRoot = resolveProjectRoot(options.projectRoot);

  console.log(`${c.bold}=== CFM SDK — verify-interactions ===${c.reset}`);
  console.log(`${c.dim}Project: ${projectRoot}${c.reset}\n`);

  const issues = scanInteractionIssues(projectRoot);
  if (issues.length) {
    console.log(`${c.red}FAIL:${c.reset} Interaction / format contract issues:`);
    for (const m of issues) console.log(`  ${m}`);
    console.log(
      `\n${c.dim}Fix: field-binding-map.md · client-lib-folder.md · layout-cookbook/mcq.md · agent-per-type-verification${c.reset}`,
    );
    return 1;
  }

  console.log(`${c.green}OK:${c.reset} Interaction contracts passed (Likert field names, star icons, MCQ pickers, matrix border contrast, slider scale zone)`);
  console.log(
    `${c.dim}Reminder: load dev URL and confirm runtime smoke in client-checkpoints.md before preview${c.reset}`,
  );
  return 0;
}
